import type { FC, ReactNode } from 'react';

import Image from 'next/image';

import FishImage from '../../images/calc.png';

import styles from './CalcIntro.module.scss';

type Props = {
	title: ReactNode;
	description: ReactNode;
	notes: ReactNode;
	actions: ReactNode;
};

export const CalcIntro: FC<Props> = ({ title, description, notes, actions }) => {
	return (
		<div className={styles.content}>
			<Image className={styles.image} src={FishImage} alt="Fish image" />
			<div className={styles.title}>{title}</div>
			<div className={styles.description}>{description}</div>
			<div className={styles.actions}>{actions}</div>
			<div className={styles.notes}>{notes}</div>
		</div>
	);
};
